export default __webpack_public_path__ + "b53344bcd473e510aec2b793904ef07b.jpg";